export default __webpack_public_path__ + "static/media/person.91d482d9.svg";